
import { mapState } from 'vuex';
import paginationMixin from '~/mixins/pagination';

export default {
    name: 'FlytippingLocation',
    mixins: [paginationMixin],
    props: {
        city: {
            type: Object,
            default: null,
        },
        county: {
            type: Object,
            default: null,
        },
        country: {
            type: Object,
            default: null,
        },
        reportsCount: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            featureReport: {},
            reports: [],
        };
    },
    async fetch() {
        const reports = await this.$axios.$get(this.$config.endpoints.report, {
            params: { [this.locationType]: this.locationParam.slug, page: this.$route.query.page || 1, per_page: 12 },
        });

        this.reports = reports?.reports?.data || [];
        [this.featureReport] = this.reports;
        this.pagination.current = reports?.reports?.current_page || 1;
        this.pagination.total = reports?.reports?.last_page || 1;
    },
    computed: {
        ...mapState(['isMobile']),
        highlightedReports() {
            return this.reports.slice(0, 3);
        },
        otherReports() {
            return this.reports.slice(3, this.reports.length);
        },
        locationParam() {
            if (this.country) {
                return this.country;
            }
            if (this.county) {
                return this.county;
            }
            if (this.city) {
                return this.city;
            }
            return {};
        },
        locationType() {
            if (this.country) {
                return 'country';
            }
            if (this.county) {
                return 'county';
            }
            return 'city';
        },
    },
    watch: {
        '$route.query': '$fetch',
    },
    updated() {
        this.$nextTick(() => {
            this.$nextTick(() => {
                if (this.$route.query.flytipping) {
                    this.$el.scrollIntoView({ behavior: 'smooth' });
                }
            });
        });
    },
};
